import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import ReactDOM from 'react-dom';

var ModalPortal = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalPortal, _React$Component);

  var _super = _createSuper(ModalPortal);

  function ModalPortal(props) {
    var _this;

    _classCallCheck(this, ModalPortal);

    _this = _super.call(this, props);
    _this.state = {
      isMounted: false
    };
    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      return ReactDOM.createPortal(this.props.children, this.el);
    }
  }]);

  return ModalPortal;
}(React.Component);

export { ModalPortal as default };